import { Link } from 'gatsby';
import React, { useState, createRef, useRef } from 'react';
import Slider from 'react-slick';
import { Sticky } from 'react-stickup';
import Typist from 'react-text-typist';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Hero from '../components/Hero';
// import IconDetails from '../components/IconDetails';
import Layout from '../components/Layout';
import Problem from '../components/Problem';
import SEO from '../components/SEO';
import Statistics from '../components/Statistics';
import { pythonBuild, testimonials } from '../utils/contentProvider';
import useMediaQuery from '../hooks/useMediaQuery';
import BeforeAfter from '../components/BeforeAfter';
import FeaturedOn from '../components/FeaturedOn';
import CoPilotIframe from '../components/CoPilotIframe';
import HowItWorks from '../components/HowItWorks';
import Solution from '../components/Solution';
import Testimonials from '../components/Testimonials';

const pythonSliderProps = {
  dots: false,
  arrows: false,
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const pythonSlideImages = [
  {
    src: '/img/home-python-slide-1.png',
    alt: 'python build slide 1',
  },
  {
    src: '/img/home-python-slide-2.png',
    alt: 'python build slide 2',
  },
  {
    src: '/img/home-python-slide-3.png',
    alt: 'python build slide 3',
  },
];

export default function Index() {
  const [tabIndex, setTabIndex] = useState(0);

  const howSectionRef = useRef();
  const isMobile = useMediaQuery('(max-width: 767px)');

  const container = createRef();
  const handleTabChange = (index) => {
    setTabIndex(index);
  };
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AlgoBulls',
    alternateName: 'Algo Trading Platform',
    url: 'https://www.algobulls.com',
    logo: 'https://www.algobulls.com/img/algobulls-logo.png',
    description:
      'AlgoBulls is a leading algo trading platform specializing in automated trading strategies and algorithmic trading solutions.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'support@algobulls.com',
      url: 'https://www.algobulls.com/help',
    },
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: '99 Wall Street, #2009',
        addressLocality: 'New York',
        addressRegion: 'NY',
        postalCode: '10005',
        addressCountry: 'USA',
      },
      {
        '@type': 'PostalAddress',
        streetAddress:
          'C-212/Mascots, 103/104, Orbit Plaza, New Prabhadevi Marg',
        addressLocality: 'Mumbai',
        addressRegion: 'MH',
        postalCode: '400025',
        addressCountry: 'India',
      },
    ],
    knowsAbout: [
      'Algorithmic Trading',
      'Automated Trading Strategies',
      'Stock Market Trading',
      'AI and ML in Trading',
      'Financial Market Analysis',
    ],
    award: [
      'Winner, Emerge 50 Awards - NASSCOM, 2024',
      'Runner-up, Best Automated Trading Software - Benzinga Fintech Awards 2024',
      'Finalist, Fintech Startup of the Year - India Fintech Awards 2024',
      'Finalist, Best Paper Trading Platform - Benzinga Fintech Awards 2024',
    ],
    sameAs: [
      'https://twitter.com/AlgoBulls',
      'https://www.linkedin.com/company/algobulls',
      'https://www.facebook.com/algobullsalgotrading',
      'https://www.crunchbase.com/organization/algobulls',
    ],
  };
  return (
    <Layout showNewBG>
      {() => (
        <>
          <SEO
            title={pythonBuild.pageTitle}
            description={pythonBuild.pageDescription}>
            <script type="application/ld+json">
              {JSON.stringify(schemaData)}
            </script>
          </SEO>
          <Hero hero={pythonBuild.hero} wrapperClassName="py-hero-wrapper" />
          <CoPilotIframe />
          <FeaturedOn />
          {/* Vision */}
          <section className="python-vision-container">
            <div className="python-vision-left">
              <h2 className="underlined-heading">Our Vision</h2>
              <p>
                To provide the most advanced and user friendly algo trading
                solution to a wide spectrum of traders.
              </p>
            </div>
            <div className="vision-image">
              <img alt="our vision" src="/img/python-vision.svg" />
            </div>
          </section>
          <Problem
            title={pythonBuild.problem.title}
            description={pythonBuild.problem.description}
            answer={pythonBuild.problem.answer}
            image={pythonBuild.problem.image}
            alt={pythonBuild.problem.alt}
          />
          {/* Solution */}
          <Solution solutions={pythonBuild.solutions} />
          <section className="working-locations pad100">
            <section className="bg-lightblue partners-main">
              <div className="partners-title">
                <h2 className="underlined-heading">Supported Exchanges</h2>
              </div>

              <div className="container">
                <Slider
                  dots={false}
                  arrows={false}
                  infinite
                  autoplay
                  speed={1100}
                  slidesToShow={5}
                  slidesToScroll={1}
                  responsive={[
                    {
                      breakpoint: 990,
                      settings: {
                        slidesToShow: 3,
                      },
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 2,
                      },
                    },
                  ]}>
                  <div>
                    <img src="/img/nasdaq.png" alt="nasdaq" />
                    <img
                      style={{ marginTop: '30px' }}
                      src="/img/us-flag.png"
                      alt="USA"
                    />
                  </div>
                  <div>
                    <img src="/img/nyse.png" alt="nyse" />
                    <img
                      style={{ marginTop: '30px' }}
                      src="/img/us-flag.png"
                      alt="USA"
                    />
                  </div>
                  <div>
                    <img src="/img/nse.jpg" alt="nse" />
                    <img
                      style={{ marginTop: '30px' }}
                      src="/img/india-flag.png"
                      alt="india"
                    />
                  </div>
                  <div>
                    <img src="/img/bse.png" alt="bse" />
                    <img
                      style={{ marginTop: '30px' }}
                      src="/img/india-flag.png"
                      alt="india"
                    />
                  </div>
                  <div>
                    <img src="/img/mcxsx.png" alt="mcxsx" />
                    <img
                      style={{ marginTop: '30px' }}
                      src="/img/india-flag.png"
                      alt="india"
                    />
                  </div>
                </Slider>
              </div>
            </section>
            <div className="container">
              <div className="flex-row align-items-center">
                <div className="col col-5">
                  <div className="locations-text">
                    <h2 className="heading">
                      Any city, Any country, Any device - Trade from anywhere
                      you want
                    </h2>
                  </div>
                </div>

                <div className="col col-7">
                  <div className="location-img">
                    <img src="/img/world-map.png" alt="Trade from online" />
                    <div className="location-pin usa-pin">
                      <svg
                        x="0px"
                        y="0px"
                        viewBox="0 0 13.5 17.7"
                        style={{ enableBackground: 'new 0 0 13.5 17.7' }}>
                        <path
                          className="st0"
                          d="M6.8,0C3,0,0,3,0,6.7c0,1.5,0.5,2.9,1.4,4l5,6.7c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2
c0,0,5-6.8,5.1-6.8c0,0,0,0,0,0c0.8-1.1,1.2-2.5,1.2-3.9C13.5,3,10.5,0,6.8,0z M6.8,10.3c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6
c2,0,3.6,1.6,3.6,3.6C10.4,8.7,8.8,10.3,6.8,10.3z"
                        />
                      </svg>

                      <div className="location-markets">
                        <div className="location-market-header">
                          <img src="/img/us-flag.png" alt="USA" />
                        </div>
                        <div className="location-market-logos">
                          <img src="/img/nyse.png" alt="nyse" />
                          <img src="/img/nasdaq.png" alt="nasdaq" />
                        </div>
                      </div>
                    </div>

                    <div className="location-pin india-pin">
                      <svg
                        x="0px"
                        y="0px"
                        viewBox="0 0 13.5 17.7"
                        style={{ enableBackground: 'new 0 0 13.5 17.7' }}>
                        <path
                          className="st0"
                          d="M6.8,0C3,0,0,3,0,6.7c0,1.5,0.5,2.9,1.4,4l5,6.7c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2
c0,0,5-6.8,5.1-6.8c0,0,0,0,0,0c0.8-1.1,1.2-2.5,1.2-3.9C13.5,3,10.5,0,6.8,0z M6.8,10.3c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6
c2,0,3.6,1.6,3.6,3.6C10.4,8.7,8.8,10.3,6.8,10.3z"
                        />
                      </svg>

                      <div className="location-markets">
                        <div className="location-market-header">
                          <img src="/img/india-flag.png" alt="India" />
                        </div>
                        <div className="location-market-logos">
                          <img src="/img/nse.jpg" alt="nse" />
                          <img src="/img/bse.png" alt="bse" />
                          <img src="/img/mcxsx.png" alt="mcxsx" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="python-stat-container-wrapper">
            <Statistics statistics={pythonBuild.statistics} />
          </div>
          {/* EntryPoint */}
          <section className="entry-main">
            <header className="build-section-heading">
              <h2 className="underlined-heading">What We Offer</h2>
              <p>We have algorithmic trading solutions for everyone</p>
            </header>
            <div className="comprehensive-tabs-main" style={{ width: '100%' }}>
              <Tabs selectedIndex={tabIndex} onSelect={handleTabChange}>
                <TabList>
                  <Tab>
                    <div className="icon">
                      <span
                        role="img"
                        aria-label="code"
                        className="anticon anticon-code">
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="code"
                          width="1em"
                          height="1em"
                          fill="#2c78f6"
                          aria-hidden="true">
                          <path d="M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path>
                        </svg>
                      </span>
                    </div>
                    <h4>Retail Solutions</h4>
                  </Tab>
                  <Tab>
                    <div className="icon">
                      <span
                        role="img"
                        aria-label="shop"
                        className="anticon anticon-shop">
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="shop"
                          width="1em"
                          height="1em"
                          fill="#2c78f6"
                          aria-hidden="true">
                          <path d="M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"></path>
                        </svg>
                      </span>
                    </div>
                    <h4>Enterprise Solutions</h4>
                  </Tab>
                </TabList>

                {/* Retail Solutions Panel */}
                <TabPanel>
                  <Tabs>
                    <TabList style={{ width: '60%', padding: 0 }}>
                      <Tab>
                        <div className="icon">
                          <span
                            role="img"
                            aria-label="phoenix"
                            className="anticon anticon-code">
                            <svg
                              viewBox="64 64 896 896"
                              focusable="false"
                              data-icon="code"
                              width="1em"
                              height="1em"
                              fill="#2c78f6"
                              aria-hidden="true">
                              <path d="M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path>
                            </svg>
                          </span>
                        </div>
                        <h5>Phoenix</h5>
                      </Tab>
                      <Tab>
                        <div className="icon">
                          <span
                            role="img"
                            aria-label="odyssey"
                            className="anticon anticon-code">
                            <svg
                              viewBox="64 64 896 896"
                              focusable="false"
                              data-icon="shop"
                              width="1em"
                              height="1em"
                              fill="#2c78f6"
                              aria-hidden="true">
                              <path d="M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"></path>
                            </svg>
                          </span>
                        </div>
                        <h5>Odyssey</h5>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <div className="entry-card-wrapper">
                        <div className="entry-card b2c-entry">
                          <div className="entry-title-img">
                            <h3>Phoenix Copilot - Our Gen AI Solution</h3>
                            <img alt="b2b entry" src="/img/genai-img.svg" />
                          </div>
                          <Link
                            className="button entry-btn"
                            to="/phoenix-copilot">
                            Explore Copilot
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                        <div className="entry-card b2c-entry">
                          <div className="entry-title-img">
                            <h3>Phoenix Pro Build- Your Custom Algorithms</h3>
                            <img
                              alt="b2b entry"
                              src="/img/custom-probuild.svg"
                            />
                          </div>
                          <Link className="button entry-btn" to="/probuild">
                            Explore Pro Build
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                        <div className="entry-card b2b-entry">
                          <div className="entry-title-img">
                            <h3>
                              Phoenix Python Build - Your Code, Our Expertise
                            </h3>
                            <img
                              src="/img/infra-img.svg"
                              alt="Strategy Development"
                            />
                          </div>
                          <Link className="button entry-btn" to="/phoenix">
                            Explore Python Build
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="entry-card-wrapper">
                        <div className="entry-card b2c-entry">
                          <div className="entry-title-img">
                            <h3>Odyssey - Our DFY Retail solution</h3>
                            <img alt="b2b entry" src="/img/b2cEntry.svg" />
                          </div>
                          <Link className="button entry-btn" to="/odyssey">
                            Explore Odyssey
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </TabPanel>

                {/* Enterprise Solutions Panel */}
                <TabPanel>
                  <div className="entry-card-wrapper">
                    <div className="entry-card b2b-entry">
                      <div className="entry-title-img">
                        <h3>Enterprises</h3>
                        <img alt="b2b entry" src="/img/b2bEntry.svg" />
                      </div>
                      <Link className="button entry-btn" to="/enterprise">
                        Explore Enterprise Solutions
                        <svg
                          x="0px"
                          y="0px"
                          viewBox="0 0 16.3 16"
                          style={{ enableBackground: 'new 0 0 16.3 16' }}>
                          <path
                            d="M1,8h14.1"
                            style={{
                              fill: 'none',
                              strokeWidth: '2',
                              strokeLinecap: 'round',
                              strokeLineJoin: 'round',
                            }}
                          />
                          <path
                            d="M8.1,1l7.1,7l-7.1,7"
                            style={{
                              fill: 'none',
                              strokeWidth: '2',
                              strokeLinecap: 'round',
                              strokeLineJoin: 'round',
                            }}
                          />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </section>
          <section className="achievements-wrapper">
            <div className="achievements-container">
              <header className="build-section-heading">
                <h2 className="underlined-heading">Our Achievements</h2>
                <p>A Legacy of Trust and Performance</p>
                <p className="python-heading-subtitle">
                  The Best Algo Trading Platform – 100% Regulatory Compliance
                  for Secure & Hassle-Free Trading
                </p>
              </header>
            </div>
            <div className="achievements-section">
              <div className="achievement-container">
                <img
                  style={{ width: '45px' }}
                  src="/img/india-flag.svg"
                  alt="india-flag"
                />
                <img
                  style={{ width: '60px' }}
                  src="/img/trophy.svg"
                  alt="trophy"
                />
                <div>
                  <h2 className="achievement-text">
                    &quot;Winner, Emerge 50 Awards&quot;
                  </h2>
                  <h2 className="achievement-text">NASSCOM, 2024</h2>
                </div>
              </div>
              <div className="achievement-container">
                <img
                  style={{ width: '45px' }}
                  src="/img/usa-flag.svg"
                  alt="usa-flag"
                />
                <img
                  style={{ width: '60px' }}
                  src="/img/trophy.svg"
                  alt="trophy"
                />
                <div>
                  <h2 className="achievement-text">
                    &quot;Best Automated Trading Software&quot;
                  </h2>
                  <h2 className="achievement-text">
                    Runner-up, Benzinga Fintech Awards 2024
                  </h2>
                </div>
              </div>
              <div className="achievement-container">
                <img
                  style={{ width: '45px' }}
                  src="/img/india-flag.svg"
                  alt="india-flag"
                />
                <img
                  style={{ width: '60px' }}
                  src="/img/trophy.svg"
                  alt="trophy"
                />
                <div>
                  <h2 className="achievement-text">
                    &quot;Fintech Startup of the Year&quot;
                  </h2>
                  <h2 className="achievement-text">
                    Finalist, India Fintech Awards 2024
                  </h2>
                </div>
              </div>
              <div className="achievement-container">
                <img
                  style={{ width: '45px' }}
                  src="/img/usa-flag.svg"
                  alt="usa-flag"
                />

                <img
                  style={{ width: '60px' }}
                  src="/img/trophy.svg"
                  alt="trophy"
                />
                <div>
                  <h2 className="achievement-text">
                    &quot;Best Paper Trading Platform&quot;
                  </h2>
                  <h2 className="achievement-text">
                    Finalist, Benzinga Fintech Awards 2024
                  </h2>
                </div>
              </div>
            </div>
          </section>
          <section className="pad100">
            <div ref={container}>
              <Sticky
                container={container}
                disabled={isMobile}
                className="sticky-container"
                style={{ zIndex: '99' }}>
                <div className="sticky-products">
                  <h2
                    className="heading text-center"
                    style={{ marginBottom: 0 }}>
                    How can AlgoBulls empower your trading pursuits
                  </h2>
                </div>
              </Sticky>
              <p
                className="text-center"
                style={{
                  maxWidth: '745px',
                  margin: '-5px auto 0',
                  zIndex: '0',
                  position: 'relative',
                }}>
                With our premier DIY (Do-It-Yourself) full code algo trading
                infrastructure PHOENIX, you can let your trading ideas run wild,
                and create simple to complex strategies without worrying about
                the technical complexities.
              </p>
              <div ref={howSectionRef} className="container">
                <div className="build-ba">
                  <BeforeAfter id={1} />
                </div>
                <div className="content-image-block bottom-border">
                  <div className="flex-row">
                    <div className="col col-6 offset-1">
                      <div className="content-block">
                        <h3 className="heading line-heading">
                          Phoenix (previously Python Build)
                        </h3>
                        <h4>
                          Want&nbsp;
                          <Typist
                            pauseTime={3000}
                            loop
                            showCursor={false}
                            sentences={[
                              'a DIY algo trading infrastructure?',
                              'to code your strategy from scratch?',
                              'Gen AI to generate your strategy?',
                              'ready templates for trading?',
                              'professional support for your trading ideas?',
                            ]}
                          />
                        </h4>
                        <p>
                          Craft, test, and execute your strategies effortlessly.
                          With Gen AI, templates, or manual coding, adapt to any
                          market on various platforms.
                          <Link to="/phoenix">
                            {' '}
                            Learn more about Phoenix and its features.
                          </Link>
                        </p>

                        <div className="content-btns">
                          <Link
                            className="button"
                            to="/phoenix"
                            style={{
                              flex: '1',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            Explore Phoenix
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                          <Link
                            className="button button-border"
                            to="/enterprise">
                            Explore Enterprise Offerings
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col col-5">
                      <div className="image-block image-drop-shadow">
                        <Slider {...pythonSliderProps}>
                          {pythonSlideImages.map((img) => (
                            <img key={img.alt} src={img.src} alt={img.alt} />
                          ))}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </div>
                <BeforeAfter id={0} />
                <div className="content-image-block">
                  <div className="flex-row">
                    <div className="col col-6 offset-1">
                      <div className="content-block">
                        <h3 className="heading line-heading">
                          Odyssey (Algo Marketplace)
                        </h3>
                        <h4>
                          Want&nbsp;
                          <Typist
                            pauseTime={3000}
                            loop
                            showCursor={false}
                            sentences={[
                              'a DFY algo trading infrastructure?',
                              'premium strategies to trade on?',
                              'a custom built strategy for you?',
                              'to create your own Algo Marketplace ?',
                            ]}
                          />
                        </h4>
                        <p>
                          With Odyssey, you get a DFY (Done-For-You) no code
                          algo trading experience. With a diverse selection of
                          pre-built strategies tailored to various trading
                          styles and needs, you can start trading efficiently
                          without the complexities of coding.
                        </p>

                        <div className="content-btns">
                          <Link
                            className="button"
                            to="/odyssey"
                            style={{
                              flex: '1',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            Explore Odyssey
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                          <Link
                            className="button button-border"
                            to="/enterprise">
                            Explore Enterprise Offerings
                            <svg
                              x="0px"
                              y="0px"
                              viewBox="0 0 16.3 16"
                              style={{ enableBackground: 'new 0 0 16.3 16' }}>
                              <path
                                d="M1,8h14.1"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                              <path
                                d="M8.1,1l7.1,7l-7.1,7"
                                style={{
                                  fill: 'none',
                                  strokeWidth: '2',
                                  strokeLinecap: 'round',
                                  strokeLineJoin: 'round',
                                }}
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col col-5">
                      <div className="image-block">
                        <img
                          src="/img/odysseyStep1.png"
                          alt="Choose Strategies"
                          style={{ transform: 'scale(0.9, 1)' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="container">
              <header className="build-section-heading">
                <h2 className="underlined-heading">how it works</h2>
                <p>
                  From amateurs to experts - everyone can easily use AlgoBulls
                  without any technical expertise
                </p>
              </header>
              <div
                className="comprehensive-tabs-main"
                style={{ width: '100%' }}>
                <HowItWorks />
              </div>
            </div>
          </section>
          <Testimonials testimonials={testimonials} />
        </>
      )}
    </Layout>
  );
}
